import React, { FC, useEffect } from "react";
import { createPortal } from "react-dom";
import Icon from "components/Elements/Icon/Icon";
import { usePicker } from "contexts/pickerContext/pickerContext";
import usePickerQueryParamActions from "./usePickerQueryParamActions";
import { useContent } from "contexts/contentContext/contentContext";

//@ts-ignore
import styles from "./styles.module.scss";

type PickerIFrameT = {
  onClose?: () => void;
};

const PickerIFrame: FC<PickerIFrameT> = (props) => {
  const { getIFrameLink } = usePicker();

  useEffect(() => {
    document.body.style.overflow = "hidden";

    return () => {
      document.body.style.overflow = "auto";
    };
  }, []);

  return getIFrameLink() ? (
    createPortal(
      <iframe
        src={getIFrameLink()}
        className={styles.iframeWindow}
        id="picker-iframe"
        title="picker-iframe"
      />,
      document.body
    )
  ) : (
    <></>
  );
};

export default PickerIFrame;
